export default __webpack_public_path__ + "static/media/alpine.5a4c765c.jpg";